/** The parts with the one at `index` moved one place up (-1) or down (1). The editor offers no move past either end. */
export function movedPart<T>(parts: T[], index: number, offset: -1 | 1): T[] {
  const neighbour = index + offset
  const moved = [...parts]
  moved[index] = parts[neighbour]
  moved[neighbour] = parts[index]
  return moved
}
